import axios from 'axios';

const API_URL = '/api/categories';

export interface Category {
    id: number;
    name: string;
    parentId?: number | null;
    parentName?: string | null;
    postCount: number;
    privateCategory: boolean;
    effectivePrivate?: boolean;
}

const authHeaders = (token?: string | null) => token ? { Authorization: `Bearer ${token}` } : undefined;

export const getCategories = async (token?: string | null) => {
    const response = await axios.get(API_URL, { headers: authHeaders(token) });
    return response.data as Category[];
};

export const getAllCategories = async (token?: string | null) => {
    const response = await axios.get(`${API_URL}/all`, { headers: authHeaders(token) });
    return response.data as Category[];
};

export const createCategory = async (name: string, privateCategory: boolean, token: string, parentId?: number | null) => {
    const response = await axios.post(API_URL, { name, privateCategory, parentId }, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data as Category;
};

export const updateCategory = async (categoryId: number, name: string, privateCategory: boolean, token: string, parentId?: number | null) => {
    const response = await axios.put(`${API_URL}/${categoryId}`, { name, privateCategory, parentId }, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data as Category;
};

export const deleteCategory = async (categoryId: number, token: string) => {
    await axios.delete(`${API_URL}/${categoryId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
};
